import { replica } from '@/shared/sync/replica';
import { type SessionInfo, sessionInfoSchema } from '../schemas/session-info';

export async function listSessions(): Promise<SessionInfo[]> {
  return sessionInfoSchema.array().parse(await replica.http.json<unknown>('/sessions'));
}
